import {
  createContext, useContext, useState, useEffect, useCallback,
} from 'react';
import { useAuth } from '../lib/auth';
import { getMyProfile } from './accountApi';

// The logged-in user's DoF profile, loaded once and shared across the account
// area. status: loading | none (no profile yet) | ready | error.
const ProfileContext = createContext(null);

export function useProfile() {
  const ctx = useContext(ProfileContext);
  if (!ctx) throw new Error('useProfile must be used inside <ProfileProvider>');
  return ctx;
}

export function ProfileProvider({ children }) {
  const { user } = useAuth();
  const [profile, setProfile] = useState(null);
  const [status, setStatus] = useState('loading');

  const load = useCallback(async () => {
    setStatus('loading');
    const { data, error } = await getMyProfile();
    if (error) { setStatus('error'); return; }
    if (!data) { setProfile(null); setStatus('none'); return; }
    setProfile(data);
    setStatus('ready');
  }, []);

  useEffect(() => {
    if (user) load();
    else { setProfile(null); setStatus('loading'); }
  }, [user, load]);

  const value = { profile, status, reload: load, setProfile };
  return <ProfileContext.Provider value={value}>{children}</ProfileContext.Provider>;
}
